import { Component } from '@angular/core';

import { Pagination } from '@shared/models/Pagination.model';
import { CrudComponent } from '@admin/components/crud/crud.component';
import { Permission } from '@admin/models/Permission.model';
import { CrudModule } from '@admin/components/crud/crud.module';

import { PermissionsFormComponent } from './permissions-form/permissions-form.component';

@Component({
    selector: 'app-permissions',
    imports: [CrudModule],
    templateUrl: '../../components/crud/crud.component.html',
    styleUrl: './permissions.component.scss'
})
export class PermissionsComponent extends CrudComponent {
  override title: string = 'Permissions';
  override data: Pagination<Permission> = new Pagination(Permission);

  override handleLoadResponse(responses: any[]): void {
    if (responses[0].data) this.data.setData(responses[0].data);

    this.pagination.set(this.data.rows.length > 0);
    this.stopLoading();
  }

  override settings(): void {
    this.showComponent = PermissionsFormComponent;
    this.editComponent = PermissionsFormComponent;
  }
}
